import { CommonModule } from "@angular/common";
import { AfterContentInit, ChangeDetectionStrategy, Component, Input, inject } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { TranslateService } from "@ngx-translate/core";
import { C_EventLive } from "@sports-models/index";
import { SportsTitleCasePipe } from "@sports-pipes/index";
import { SportsExtractDatePipe } from "@sports-pipes/sports.extract-date.pipe";
import { SportHandleList } from "@sports-utils/sport-handle-list";
import { sportsLiterals } from "@sports-utils/sports.constants";

@Component({
  selector: "sports-grid-content-teams",
  templateUrl: "./sports-grid-content-teams.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [SportsTitleCasePipe, CommonModule, FormsModule],
  styleUrls: ["./sports-grid-content-teams.scss"],
})
export class SportsGridContentTeamsComponent implements AfterContentInit {
  home: string;
  away: string;
  date: string;
  pitcherHome: string;
  pitcherAway: string;
  isLive = false;
  matchTime: string;
  @Input() event: C_EventLive | any;

  translate = inject(TranslateService);
  constructor(private sportsExtractDate: SportsExtractDatePipe) {}

  ngAfterContentInit() {
    if (this.event) {
      this.home = this.event.teamHome;
      this.away = this.event.teamAway;
      this.pitcherHome = this.event.pitcherHome;
      this.pitcherAway = this.event.pitcherAway;
      this.isLive = !!this.event.StreamingEnabled;

      if (this.event.liveData) {
        if (this.event.liveData.PeriodName && this.eventHasPeriod() && this.eventNotDarts()) {
          this.date = this.event.liveData.PeriodName;
          if (this.event.liveData.PeriodName.toLowerCase().includes("penal")) {
            this.date = this.translate.instant("SPO_Penalties");
            this.matchTime = "";
            return;
          }
        }
        if (this.event.liveData.RemainingPeriodTime) {
          if (
            this.event.liveData.RemainingPeriodTime === sportsLiterals.RemainingPeriodTimeNull ||
            this.event.liveData.PeriodName === sportsLiterals.Descanso
          ) {
            return;
          }
          this.matchTime = "< " + this.event.liveData.RemainingPeriodTime;
          return;
        }
        if (this.event.liveData.MatchTime > 0 && this.event.liveData.PeriodName !== sportsLiterals.Descanso) {
          this.matchTime = this.event.liveData.MatchTime + "'";
        }
      } else {
        this.date = this.sportsExtractDate.transform(this.event.StartDate);
      }
    }
  }

  private eventHasPeriod() {
    return this.event.SportHandle.toLowerCase() !== SportHandleList.esports;
  }

  private eventNotDarts() {
    return this.event.SportHandle !== SportHandleList.darts;
  }
}
